import { render, staticRenderFns } from "./payment-detail.vue?vue&type=template&id=2f9df6ea&scoped=true"
import script from "./payment-detail.vue?vue&type=script&lang=js"
export * from "./payment-detail.vue?vue&type=script&lang=js"
import style0 from "./payment-detail.vue?vue&type=style&index=0&id=2f9df6ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9df6ea",
  null
  
)

export default component.exports